import { render, staticRenderFns } from "./c2cOrder.vue?vue&type=template&id=73e12fa9&scoped=true&"
import script from "./c2cOrder.vue?vue&type=script&lang=js&"
export * from "./c2cOrder.vue?vue&type=script&lang=js&"
import style0 from "./c2cOrder.vue?vue&type=style&index=0&id=73e12fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e12fa9",
  null
  
)

export default component.exports